import type { ResourceResponse } from "types";
import type { BankingSdkConnector } from "features/openBanking/types";
import { useBankingSDKActions } from "features/openBanking/actions";
import { useOpenBankingResource, useToggleEnabledOpenBankingResource } from "../shared";

export default function useBankingSDK() {
    const { onRowClick } = useOpenBankingResource();

    const { updateBankingSdkConnector } = useBankingSDKActions();

    const {
        getBankingSdkConnectors: getResource,
        downloadCsv
    } = useBankingSDKActions();

    return {
        ...useToggleEnabledOpenBankingResource({
            handleChangeRequest: changePayload => {
                const [request] = updateBankingSdkConnector(changePayload);

                return request as Promise<ResourceResponse<BankingSdkConnector>>;
            },
        }),
        downloadCsv,
        getResource,
        onRowClick
    };
};
